// HomeBanner.js
import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "./HomeBanner.css";

// 🔹 Custom Arrows
const CustomPrevArrow = ({ onClick }) => (
  <button className="custom-arrow prev-arrow" onClick={onClick}>
    &#8592;
  </button>
);

const CustomNextArrow = ({ onClick }) => (
  <button className="custom-arrow next-arrow" onClick={onClick}>
    &#8594;
  </button>
);

const HomeBanner = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);

  const settings = {
    dots: true,
    infinite: banners.length > 1,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: banners.length > 1,
    autoplaySpeed: 6000,
    arrows: banners.length > 1,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
  };

  useEffect(() => {
    fetch("https://api.mitradingjp.com/get-car-banner.php")
      .then((res) => res.json())
      .then((data) => {
        setBanners(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Banner fetch error:", error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div className="text-center py-5">Loading banners...</div>;
  }

  return (
    <div className="home-banner-container mt-3">
      <Slider {...settings}>
        {banners.map((banner, index) => (
          <div className="slider-item" key={index}>
            <img
              src={`https://api.mitradingjp.com/${banner.image_path}`}
              alt="Banner"
              className="slider-image"
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default HomeBanner;